export const getSimilarityColor = (value?: number | null) => {
  if (value === undefined || value === null) return 'text-white'
  if (value >= 0.8) return 'text-valid'
  if (value >= 0.7) return 'text-yellow-400'
  return 'text-danger-soft'
}
